export const boxApiBaseUrl = "https://api.box.com/2.0";
export const boxUploadBaseUrl = "https://upload.box.com/api/2.0";
export const BOX_FOLDER_NAME_MAX_LENGTH = 255;
export const BOX_APP_USER_NAME_MAX_LENGTH = 50;
